import store from './store';
import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, setToken, removeToken, removeStation } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']

router.beforeEach((to, from, next) => {
  NProgress.start() 
  if (getToken()) {
    /* has token*/
    if (!store.getters.isLoadRoute) {
      store.dispatch('getMenu').then(res => {
        const routes = generateRoutes(res);
        const Layout = r => require.ensure([], () => r(require('@/views/layout/Layout')))
        router.addRoutes([{ path: '/', component: Layout, children: routes }]);
        store.dispatch('loadRoute')
        if (to.path === '/login') {
          next({ path: '/' })
          NProgress.done()
        } else {
        	
        	if(to.path == '/power/real/dashboard'){ 
        			let routes = store.getters.routes
        		let dashboard = false
        		let distributionMap = false
	        	routes.forEach(item=>{
	            		if(item.href =="/power/real/dashboard"){
	            			dashboard = true
	            		} 
	            		if(item.href =="/power/power_distribution/map"){
	            			distributionMap = true
	            		} 
		            	if(item.children ){
		            		item.children.forEach(item2=>{
		            			if(item2.href =="/power/power_distribution/map"){
			            			distributionMap = true
			            		} 
		            		})
		            	}
	         }) 
        		if(dashboard){//如果返回菜单有/power/real/dashboard
        			next({ ...to }) 
        		}else if(distributionMap){//如果返回菜单有/power/power_distribution/map
        		next({ path: '/power/power_distribution/map'}) 
        		}else{
        			let fal =false
        			let href = ''
        			for(var i=0;i<routes.length;i++){ 
                  if(routes[i].children && !fal){
                    for(var t=0;t<routes[i].children.length;t++){
                      if(routes[i].children[t].href && !fal){
                        href = routes[i].children[t].href
                        fal = true
                        break
                    	}
                  	}
                	} 
							}
        			if(fal){ //默认第一个下拉第一个菜单
									next({ path: href})  
							}else{ //
        				next({ ...to })  
							}
        		}
        	}else{
        		next({ ...to }) 
        	} 
        }
      }).catch(() => {
        //session失效
        removeToken();
        removeStation();
        next('/login')
        NProgress.done()
      })
    } else {
      if (to.path === '/login') {
        next({ path: '/' })
        NProgress.done()
      } else {
        next()
      }
    }
  } else { 
    /* has no token*/
    if (window.location.hash == '#/hnac_largeScreen') {
//    const { requestPath } = Vue.config;
//    let account = 'pdadmin'
//    const data = { account: account, pwd: 'pd1234' }; 
//    hz.ajax.post(`${requestPath}/vue/login`, hz.location.getString(data), { contentType: 'application/x-www-form-urlencoded; charset=UTF-8' }).then(res => {
//       
//      if (res.status == 0) {
//
//      } else {
//        setToken(account)
//        next({ path: '/power/power_distribution/map' })
//      }
//    })
   		next()
    } else if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})


function generateRoutes(routes) {
  let pageRoutes = [];

  let loadPackage = function (obj, packageName) {
    if (obj.path) {
      if (obj.redirect) {
        let pathArray = obj.redirect.split("?");
        if (pathArray.length > 1) {
          obj.redirect = {
            path: pathArray[0],
            query: hz.location.formatParams(pathArray[1])
          }
        }
        pageRoutes.push(obj);
      } else {
        let pathArray = obj.path.split("?");
        let path = pathArray[0]
        let isIframe = pathArray[1] && pathArray[1].indexOf("iframe") > -1
        if (isIframe) {
          let Page = r => require.ensure([], () => r(require('@/views/commons/iframe.vue')));
          const route = {
            path: path,
            component: Page,
            name: obj.title,
            meta: { icon: obj.icon, href: obj.href }
          }
          pageRoutes.push(route);
        } else {
          let Page = r => require.ensure([], () => r(require('@/views' + (obj.filePath || path))));
          // let Page = () => import('@/views' + (obj.filePath || obj.path) );
          const route = {
            path: path,
            component: Page,
            name: obj.title,
            meta: { icon: obj.icon }
          }
          pageRoutes.push(route);
        }
      }
    }
    if (obj.children) {
      obj.children.map(one => {
        loadPackage(one, packageName);
      });
    }
  }

  routes.map(one => {
    let packageName = one.title;
    loadPackage(one, packageName);
  })
  return pageRoutes;
}


// WEBPACK FOOTER //
// ./src/permission.js